import PropTypes from 'prop-types';
import React from 'react';

import Column from '../../components/Column'
import ColumnWrapper from '../../components/ColumnWrapper'

import LabeledInput from '../../components/forms/LabeledInput'

import {reduxForm} from 'redux-form'

function OrderNoteForm(props) {

    return (
        <ColumnWrapper>
            <Column>
                <LabeledInput fieldId="note" label="" isOptional={true} placeholder="Hinweise, Fragen, Wünsche o.ä."/>
            </Column>
        </ColumnWrapper>
    )
}

OrderNoteForm.propTypes = {
    forceValidation: PropTypes.bool
};

OrderNoteForm.defaultProps = {
    forceValidation: false
};

OrderNoteForm = reduxForm({form: 'existingUserNote', destroyOnUnmount: false})(OrderNoteForm) // eslint-disable-line

export default OrderNoteForm


/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/OrderNoteForm.js
 **/